import { useEffect } from 'react'

// Клики внутри всплывающих частей (выпадающий список, подсказки, вложенные
// подтверждения) — это всё ещё «внутри» облачка, хоть они и живут порталом.
const INSIDE =
  '[data-publish-panel],[data-publish-trigger],[data-radix-popper-content-wrapper],[role="dialog"],[role="alertdialog"],[data-sonner-toaster]'

/** Облачко закрывается кликом мимо и клавишей Escape. */
export const useDismissPanel = (open: boolean, close: () => void) => {
  useEffect(() => {
    if (!open) return
    const onDown = (e: PointerEvent) => {
      const target = e.target as Element | null
      if (target?.closest(INSIDE)) return
      close()
    }
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') close()
    }
    document.addEventListener('pointerdown', onDown)
    document.addEventListener('keydown', onKey)
    return () => {
      document.removeEventListener('pointerdown', onDown)
      document.removeEventListener('keydown', onKey)
    }
  }, [open, close])
}
